import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../app/auth/auth.service';
import { inject } from '@angular/core';
import { map, take } from 'rxjs';
import { LocalService } from '../services/local.service';

export const authGuard: CanActivateFn = (route, state) => {
  // return true;
  const authService = inject(AuthService);
  const router = inject(Router);
  const localService = inject(LocalService);
  
  const loginUser=localService.getJsonValue('loginUserData');
  const loginTimestamp = localService.getJsonValue('loginTimestamp');


    // Current timestamp
    const currentTimestamp = new Date().getTime();

     // Calculate the 24-hour limit in milliseconds
  const oneDayInMillis = 24 * 60 * 60 * 1000;

  return authService.user.pipe(
    take(1),
    map((user:any) => {
        const userData=JSON.stringify(user)
        if (user && loginUser && (userData == loginUser) &&  loginTimestamp &&
        currentTimestamp - loginTimestamp < oneDayInMillis) {
            return true;
        }
        localStorage.clear();
        return router.createUrlTree(['login'])
    })
  );



};
